import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center space-x-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-2xl font-bold text-gray-900 dark:text-white" }
const _hoisted_6 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_7 = { class: "flex items-center space-x-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "p-6"
}
const _hoisted_11 = {
  key: 1,
  class: "p-6"
}
const _hoisted_12 = { class: "bg-red-50 dark:bg-red-900 border border-red-200 dark:border-red-700 rounded-md p-4" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "ml-3" }
const _hoisted_15 = { class: "mt-2 text-sm text-red-700 dark:text-red-300" }
const _hoisted_16 = {
  key: 2,
  class: "p-6 space-y-6"
}
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-5 gap-4" }
const _hoisted_18 = { class: "mr-1" }
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 1,
  class: "text-sm text-gray-400"
}
const _hoisted_21 = { class: "text-xl font-bold text-red-600 dark:text-red-400" }
const _hoisted_22 = { class: "text-xl font-bold text-yellow-600 dark:text-yellow-400" }
const _hoisted_23 = { class: "text-xl font-bold text-gray-900 dark:text-white" }
const _hoisted_24 = { class: "flex items-center justify-between" }
const _hoisted_25 = { class: "flex items-center space-x-4" }
const _hoisted_26 = { class: "flex items-center space-x-2 text-sm" }
const _hoisted_27 = { class: "flex items-center space-x-2 text-sm" }
const _hoisted_28 = { class: "flex items-center space-x-2 text-sm" }
const _hoisted_29 = { class: "space-y-4" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "flex items-center justify-between" }
const _hoisted_32 = { class: "flex items-center space-x-3" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 1,
  class: "ml-2 text-sm text-gray-500 dark:text-gray-400"
}
const _hoisted_37 = { class: "flex items-center space-x-4" }
const _hoisted_38 = { class: "flex items-center space-x-2 text-sm" }
const _hoisted_39 = {
  key: 0,
  class: "text-red-600 dark:text-red-400"
}
const _hoisted_40 = {
  key: 1,
  class: "text-yellow-600 dark:text-yellow-400"
}
const _hoisted_41 = { class: "border-t border-gray-200 dark:border-gray-700" }
const _hoisted_42 = {
  key: 0,
  class: "divide-y divide-gray-200 dark:divide-gray-700"
}
const _hoisted_43 = { class: "flex items-start justify-between" }
const _hoisted_44 = { class: "flex-1" }
const _hoisted_45 = { class: "flex items-center space-x-2" }
const _hoisted_46 = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400 font-mono"
}
const _hoisted_47 = { class: "mt-1 text-sm text-gray-900 dark:text-white" }
const _hoisted_48 = ["href"]
const _hoisted_49 = {
  key: 1,
  class: "px-4 py-3 text-sm text-gray-500 dark:text-gray-400 italic"
}
const _hoisted_50 = {
  key: 3,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_51 = { class: "flex items-center justify-center min-h-screen px-4" }
const _hoisted_52 = { class: "flex justify-end space-x-3" }
const _hoisted_53 = ["disabled"]

import { ref, computed, onMounted, inject, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useTheme } from '../../utils/useTheme'
import { qualityGatesService } from '../../services/quality-gates'
import NetworkAccessHint from '../../components/shared/NetworkAccessHint.vue'
import type { QualityGatePRDetails, GateResult, GateStatus } from '../../types/quality-gates'
import { logger } from '../../utils/logger'

interface FlattenedGate {
  key: string
  script: string
  team: string
  result: GateResult
}


export default /*@__PURE__*/_defineComponent({
  __name: 'details',
  setup(__props) {

const route = useRoute()
const theme = inject('theme', useTheme())

// State
const prDetails = ref<QualityGatePRDetails | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)
const retriggering = ref(false)
const showRetriggerModal = ref(false)

// Filter state
const showFailures = ref(true)
const showWarnings = ref(true)
const showPassing = ref(false)
const expandAll = ref(false)
const expandedGates = ref<Set<string>>(new Set())

// Route params
const repository = computed(() => decodeURIComponent(route.params.repo as string))
const prNumber = computed(() => parseInt(route.params.prNumber as string, 10))

// Flatten gate results for easier rendering
const flattenedGates = computed<FlattenedGate[]>(() => {
  if (!prDetails.value?.results) return []

  const gates: FlattenedGate[] = []
  for (const [script, teams] of Object.entries(prDetails.value.results)) {
    for (const [team, result] of Object.entries(teams)) {
      gates.push({
        key: `${script}-${team}`,
        script,
        team,
        result: result as GateResult
      })
    }
  }

  // Sort: failures first, then warnings, then success
  const statusOrder: Record<GateStatus, number> = { failure: 0, warning: 1, success: 2 }
  gates.sort((a, b) => statusOrder[a.result.status] - statusOrder[b.result.status])

  return gates
})

// Filter gates based on status toggles
const filteredGates = computed(() => {
  return flattenedGates.value.filter((gate) => {
    if (gate.result.status === 'failure' && showFailures.value) return true
    if (gate.result.status === 'warning' && showWarnings.value) return true
    if (gate.result.status === 'success' && showPassing.value) return true
    return false
  })
})

const totalGates = computed(() => flattenedGates.value.length)

// Methods
const fetchPRDetails = async () => {
  try {
    loading.value = true
    error.value = null

    logger.log('Fetching PR details:', { repository: repository.value, prNumber: prNumber.value })

    const response = await qualityGatesService.fetchPRDetails(repository.value, prNumber.value)
    prDetails.value = response

    logger.log('PR details fetched:', response)
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to fetch PR details'
    logger.error('Error fetching PR details:', err)
  } finally {
    loading.value = false
  }
}

const refreshDetails = () => {
  fetchPRDetails()
}

const toggleGate = (key: string) => {
  if (expandedGates.value.has(key)) {
    expandedGates.value.delete(key)
  } else {
    expandedGates.value.add(key)
  }
  // Force reactivity
  expandedGates.value = new Set(expandedGates.value)
}

const handleRetrigger = async () => {
  try {
    retriggering.value = true

    await qualityGatesService.retriggerPR(repository.value, prNumber.value)

    showRetriggerModal.value = false

    // Show success message (could use a toast here)
    logger.log('Re-trigger successful')
  } catch (err) {
    logger.error('Failed to re-trigger:', err)
    // Could show error toast
  } finally {
    retriggering.value = false
  }
}

// Watch for expand all toggle
watch(expandAll, (newValue) => {
  if (newValue) {
    expandedGates.value = new Set(flattenedGates.value.map((g) => g.key))
  } else {
    expandedGates.value = new Set()
  }
})

// Lifecycle
onMounted(() => {
  fetchPRDetails()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/quality-gates')))
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M15 19l-7-7 7-7"
              })
            ], -1),
            _createElementVNode("span", null, "Back to Quality Gates", -1)
          ])),
          (prDetails.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h1", _hoisted_5, _toDisplayString(prDetails.value.repository) + " #" + _toDisplayString(prDetails.value.pr_number), 1),
                _createElementVNode("p", _hoisted_6, " Last updated " + _toDisplayString(_unref(qualityGatesService).formatTimestamp(prDetails.value.last_updated)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            disabled: retriggering.value,
            class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-blue-600 hover:bg-blue-700'
                : 'bg-blue-600 hover:bg-blue-700',
              'px-4 py-2 text-white rounded-md text-sm font-medium transition-colors flex items-center',
              retriggering.value ? 'opacity-50 cursor-not-allowed' : ''
            ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showRetriggerModal.value = true))
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([retriggering.value ? 'animate-spin' : '', 'w-4 h-4 mr-2']),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              }, null, -1)
            ]), 2)),
            _createTextVNode(" " + _toDisplayString(retriggering.value ? 'Triggering...' : 'Re-trigger Gates'), 1)
          ], 10, _hoisted_8),
          _createElementVNode("button", {
            disabled: loading.value,
            class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-gray-700 hover:bg-gray-600 text-gray-200'
                : 'bg-white hover:bg-gray-50 text-gray-700',
              'px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium transition-colors'
            ]),
            onClick: refreshDetails
          }, " Refresh ", 10, _hoisted_9)
        ])
      ])
    ], 2),
    (loading.value && !prDetails.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-8'
        ])
          }, _cache[11] || (_cache[11] = [
            _createStaticVNode("<div class=\"flex items-center justify-center\"><svg class=\"animate-spin h-8 w-8 text-blue-500\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z\"></path></svg><span class=\"ml-3 text-lg text-gray-600 dark:text-gray-300\">Loading PR details...</span></div>", 1)
          ]), 2)
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[13] || (_cache[13] = _createElementVNode("svg", {
                  class: "h-5 w-5 text-red-400",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_14, [
                  _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-sm font-medium text-red-800 dark:text-red-200" }, " Error loading PR details ", -1)),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(error.value), 1),
                  _createVNode(NetworkAccessHint),
                  _createElementVNode("button", {
                    class: "mt-2 px-3 py-1 bg-red-100 dark:bg-red-800 text-red-800 dark:text-red-100 rounded text-sm",
                    onClick: refreshDetails
                  }, " Try Again ")
                ])
              ])
            ])
          ]))
        : (prDetails.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-6',
          `border-l-4 ${_unref(qualityGatesService).getStatusBorderColor(prDetails.value.status)}`
        ])
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400 mb-1" }, "Status", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass([
                _unref(qualityGatesService).getStatusColor(prDetails.value.status || 'unknown'),
                'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium'
              ])
                    }, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(qualityGatesService).getStatusIcon(prDetails.value.status || 'unknown')), 1),
                      _createTextVNode(" " + _toDisplayString((prDetails.value.status || 'UNKNOWN').toUpperCase()), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400 mb-1" }, "Commit", -1)),
                    (prDetails.value.commit_sha)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: `https://github.com/GoHighLevel/${prDetails.value.repository}/commit/${prDetails.value.commit_sha}`,
                          target: "_blank",
                          class: "font-mono text-sm text-blue-600 dark:text-blue-400 hover:underline"
                        }, _toDisplayString(prDetails.value.commit_sha.substring(0, 7)), 9, _hoisted_19))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, "N/A"))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400 mb-1" }, "Errors", -1)),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(prDetails.value.total_errors ?? 0), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400 mb-1" }, "Warnings", -1)),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(prDetails.value.total_warnings ?? 0), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400 mb-1" }, "Gates Run", -1)),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(totalGates.value), 1)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-4'
        ])
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Show:", -1)),
                    _createElementVNode("label", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showFailures).value = $event)),
                        type: "checkbox",
                        class: "rounded text-red-500 focus:ring-red-500"
                      }, null, 512), [
                        [_vModelCheckbox, showFailures.value]
                      ]),
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-red-600 dark:text-red-400" }, "Failures", -1))
                    ]),
                    _createElementVNode("label", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showWarnings).value = $event)),
                        type: "checkbox",
                        class: "rounded text-yellow-500 focus:ring-yellow-500"
                      }, null, 512), [
                        [_vModelCheckbox, showWarnings.value]
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-yellow-600 dark:text-yellow-400" }, "Warnings", -1))
                    ]),
                    _createElementVNode("label", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showPassing).value = $event)),
                        type: "checkbox",
                        class: "rounded text-green-500 focus:ring-green-500"
                      }, null, 512), [
                        [_vModelCheckbox, showPassing.value]
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-green-600 dark:text-green-400" }, "Passing", -1))
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "text-sm text-blue-600 dark:text-blue-400 hover:underline",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (expandAll.value = !expandAll.value))
                  }, _toDisplayString(expandAll.value ? 'Collapse All' : 'Expand All'), 1)
                ])
              ], 2),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGates.value, (gate) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: gate.key,
                    class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-lg overflow-hidden'
          ])
                  }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["w-full px-4 py-3 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset", [_unref(theme).isDark.value ? 'hover:bg-gray-700' : 'hover:bg-gray-50']]),
                      onClick: ($event: any) => (toggleGate(gate.key))
                    }, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("span", {
                            class: _normalizeClass([
                    _unref(qualityGatesService).getStatusColor(gate.result.status),
                    'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'
                  ])
                          }, _toDisplayString(_unref(qualityGatesService).getStatusIcon(gate.result.status)), 3),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(qualityGatesService).formatGateName(gate.script)), 1),
                            (_unref(qualityGatesService).hasGateDocumentation(gate.script))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _unref(qualityGatesService).getGateDocumentationUrl(gate.script),
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "ml-2 text-xs text-blue-600 dark:text-blue-400 hover:underline hover:text-blue-700 dark:hover:text-blue-300",
                                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                                }, " [docs] ", 8, _hoisted_35))
                              : _createCommentVNode("", true),
                            (gate.team)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, " (" + _toDisplayString(gate.team) + ") ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          (gate.result.summary?.blockDate)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([
                    _unref(qualityGatesService).getBlockDateInfo(gate.result.summary.blockDate).colorClass,
                    'text-xs flex items-center'
                  ])
                              }, [
                                _cache[23] || (_cache[23] = _createElementVNode("svg", {
                                  class: "w-3.5 h-3.5 mr-1",
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_unref(qualityGatesService).getBlockDateInfo(gate.result.summary.blockDate).text), 1)
                              ], 2))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_38, [
                            (gate.result.summary?.errorCount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(gate.result.summary.errorCount) + " errors ", 1))
                              : _createCommentVNode("", true),
                            (gate.result.summary?.warningCount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(gate.result.summary.warningCount) + " warnings ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(), _createElementBlock("svg", {
                            class: _normalizeClass([
                    'w-5 h-5 text-gray-400 transform transition-transform',
                    expandedGates.value.has(gate.key) ? 'rotate-180' : ''
                  ]),
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, _cache[24] || (_cache[24] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 9l-7 7-7-7"
                            }, null, -1)
                          ]), 2))
                        ])
                      ])
                    ], 10, _hoisted_30),
                    _withDirectives(_createElementVNode("div", _hoisted_41, [
                      (gate.result.details?.issues && gate.result.details.issues.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gate.result.details.issues, (violation, vIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: vIndex,
                                class: _normalizeClass(["px-4 py-3", [_unref(theme).isDark.value ? 'bg-gray-850' : 'bg-gray-50']])
                              }, [
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", _hoisted_45, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass([
                          violation.severity?.toLowerCase() === 'error'
                            ? 'text-red-600 dark:text-red-400'
                            : violation.severity?.toLowerCase() === 'warning'
                              ? 'text-yellow-600 dark:text-yellow-400'
                              : 'text-blue-600 dark:text-blue-400',
                          'text-xs font-medium uppercase'
                        ])
                                      }, _toDisplayString(violation.severity), 3),
                                      (violation.ruleId)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(violation.ruleId), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("p", _hoisted_47, _toDisplayString(violation.message), 1),
                                    (violation.file && violation.line)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: 
                        _unref(qualityGatesService).getViolationLink(
                          prDetails.value.repository,
                          prDetails.value.commit_sha,
                          violation.file,
                          violation.line
                        )
                      ,
                                          target: "_blank",
                                          class: "mt-1 text-xs font-mono text-blue-600 dark:text-blue-400 hover:underline flex items-center"
                                        }, [
                                          _createTextVNode(_toDisplayString(violation.file) + ":" + _toDisplayString(violation.line) + " ", 1),
                                          _cache[25] || (_cache[25] = _createElementVNode("svg", {
                                            class: "w-3 h-3 ml-1",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                            })
                                          ], -1))
                                        ], 8, _hoisted_48))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 2))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_49, " No violations found "))
                    ], 512), [
                      [_vShow, expandedGates.value.has(gate.key) || expandAll.value]
                    ])
                  ], 2))
                }), 128))
              ]),
              (filteredGates.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-8 text-center'
        ])
                  }, _cache[26] || (_cache[26] = [
                    _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "No gates match the current filters.", -1)
                  ]), 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
    (showRetriggerModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", {
              class: "fixed inset-0 bg-black opacity-50",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (showRetriggerModal.value = false))
            }),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
            'relative rounded-lg shadow-xl max-w-md w-full p-6'
          ])
            }, [
              _cache[27] || (_cache[27] = _createStaticVNode("<h3 class=\"text-lg font-medium text-gray-900 dark:text-white mb-4\"> Re-trigger Quality Gates </h3><p class=\"text-sm text-gray-500 dark:text-gray-400 mb-4\"> Are you sure you want to re-trigger quality gates for this PR? </p><div class=\"bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md p-3 mb-4\"><div class=\"flex\"><svg class=\"h-5 w-5 text-yellow-400\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\" clip-rule=\"evenodd\"></path></svg><p class=\"ml-2 text-sm text-yellow-700 dark:text-yellow-200\"> Results will only change if the quality gate rules have been updated. </p></div></div>", 3)),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("button", {
                  class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-gray-700 hover:bg-gray-600 text-gray-200'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700',
                'px-4 py-2 rounded-md text-sm font-medium'
              ]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (showRetriggerModal.value = false))
                }, " Cancel ", 2),
                _createElementVNode("button", {
                  disabled: retriggering.value,
                  class: "px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium",
                  onClick: handleRetrigger
                }, _toDisplayString(retriggering.value ? 'Triggering...' : 'Confirm Re-trigger'), 9, _hoisted_53)
              ])
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})